// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"de62c6a0cb993c0a","5285":"36ee315f8d78c7a2"}[chunkId] + ".css";
};